import ShippingMaterials from './ShippingMaterialsContainer';

export default ShippingMaterials

